import { useI18n } from './I18nProvider';
import { LOCALES, LOCALE_LABELS, type Locale } from './types';

export interface LanguageSwitcherProps {
  className?: string;
  /** Visual variant: light backgrounds vs dark navy. */
  tone?: 'light' | 'dark';
}

export function LanguageSwitcher({ className, tone = 'light' }: LanguageSwitcherProps) {
  const { locale, setLocale } = useI18n();

  const baseLight =
    'inline-flex items-center gap-1 rounded-full border border-[#3D3328]/15 bg-white/80 px-1 py-1 text-xs';
  const baseDark =
    'inline-flex items-center gap-1 rounded-full border border-white/15 bg-white/5 px-1 py-1 text-xs';

  const itemLightActive = 'bg-[#1A1A1A] text-[#F4D03F]';
  const itemLightInactive = 'text-[#3D3328] hover:text-[#1A1A1A]';
  const itemDarkActive = 'bg-[#EDB24A] text-[#0A1628]';
  const itemDarkInactive = 'text-white/70 hover:text-white';

  return (
    <div className={[tone === 'dark' ? baseDark : baseLight, className].filter(Boolean).join(' ')}>
      {LOCALES.map((next: Locale) => {
        const isActive = locale === next;
        const itemClass = [
          'rounded-full px-3 py-1 transition-colors',
          isActive
            ? tone === 'dark'
              ? itemDarkActive
              : itemLightActive
            : tone === 'dark'
              ? itemDarkInactive
              : itemLightInactive,
        ].join(' ');
        return (
          <button
            key={next}
            type="button"
            onClick={() => setLocale(next)}
            className={itemClass}
            aria-pressed={isActive}
          >
            {LOCALE_LABELS[next]}
          </button>
        );
      })}
    </div>
  );
}
